import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { C } from "./tokens";
import { SLUG_REDIRECTS } from "./data/services";
import GlobalStyles from "./components/GlobalStyles";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import Cursor from "./components/Cursor";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const HomePage           = lazy(() => import("./pages/HomePage"));
const PlansPage          = lazy(() => import("./pages/PlansPage"));
const CategoryDetailPage = lazy(() => import("./pages/CategoryDetailPage"));
const AboutPage          = lazy(() => import("./pages/AboutPage"));
const TeamPage           = lazy(() => import("./pages/TeamPage"));
const TestimonialsPage   = lazy(() => import("./pages/TestimonialsPage"));
const FaqsPage           = lazy(() => import("./pages/FaqsPage"));
const ContactPage        = lazy(() => import("./pages/ContactPage"));
const NotFound           = lazy(() => import("./pages/NotFound"));

function RouteFallback() {
  return (
    <div style={{ minHeight: "100vh", background: C.cream, padding: "120px 5vw" }}>
      <div className="skel" style={{ height: "40vh", marginBottom: "24px" }}/>
      <div className="skel" style={{ height: "20vh" }}/>
    </div>
  );
}

// Old /services/:slug links map to their new plan category so shared or indexed
// URLs keep resolving. Netlify also 301s these server-side (public/_redirects).
function LegacyServiceRedirect() {
  const { slug } = useParams();
  const target = SLUG_REDIRECTS[slug];
  return <Navigate to={target ? `/plans/${target}` : "/plans"} replace />;
}

function AppShell() {
  return (
    <div>
      <GlobalStyles/>
      <ScrollToTop/>
      <Cursor/>
      <Nav/>
      <main>
        <ErrorBoundary>
          <Suspense fallback={<RouteFallback/>}>
            <Routes>
              <Route path="/"                element={<HomePage/>}/>
              <Route path="/plans"           element={<PlansPage/>}/>
              <Route path="/plans/:slug"     element={<CategoryDetailPage/>}/>
              <Route path="/services"        element={<Navigate to="/plans" replace/>}/>
              <Route path="/services/:slug"  element={<LegacyServiceRedirect/>}/>
              <Route path="/about"           element={<AboutPage/>}/>
              <Route path="/team"            element={<TeamPage/>}/>
              <Route path="/testimonials"    element={<TestimonialsPage/>}/>
              <Route path="/faqs"            element={<FaqsPage/>}/>
              <Route path="/contact"         element={<ContactPage/>}/>
              <Route path="*"                element={<NotFound/>}/>
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </main>
      <Footer/>
      <WhatsAppButton/>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell/>
    </BrowserRouter>
  );
}
